// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"efd3a2a5","423":"0f8ba125","448":"bc3d7789"}[chunkId] + ".chunk.js";
};